import React, { useState } from "react";
import { Button, Row, Col, Tooltip } from "reactstrap";
import Combobox from "../Combobox";
import { Field } from "../Field";
import Requeriments from "./Requeriments";
import { UserType } from "../../../../../utils/Helper";
import CircularProgress from "../../../../CircularProgress/CircularProgress";
import style from "./Account.module.scss";

const Instruction = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const items = (() => {
    if (props.items == null || props.items.length == 0) {
      if (props.value != null) {
        return [
          {
            id: props.value,
            description: props.value,
          },
        ];
      }
      return [];
    }

    return props.items;
  })();

  const value = props.items != null ? props.value : items.length ? props.value : -1;

  const { error } = props;
  const {
    setAttachment,
    downloadAttachment,
    hasAttachment,
    attachmentDisabled,
    onResendAuth,
    orderPdf,
    orderId,
    accountId,
    onChangeOrder,
    userType,
    canResend,
    sendingMail,
    hasFile,
    isProp,
    ...restProps
  } = props;

  const setUploaded = (props) => {
    if (props.hasAttachment && props.hasAttachment.uploadPending) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <React.Fragment>
      <Row>
        {!isProp && (
          <Col>
            <Field label="Instruction" error={error}>
              <Combobox
                emptyLabel="Instruction"
                {...restProps}
                disabled={props.disabled || setUploaded(props)}
                items={items}
                invalid={!!error}
                value={value}
              />
            </Field>
          </Col>
        )}

        {canResend && (
          <Col style={{ flexGrow: 0, margin: "auto" }}>
            {sendingMail ? (
              <CircularProgress sm />
            ) : (
              <React.Fragment>
                <Button
                  id="tooltipResend"
                  color="btn-outline-primary btn-sm"
                  onClick={() => onResendAuth(orderId, accountId)}
                >
                  <i className="fa fa-send" />
                </Button>
                <Tooltip placement="top" target="tooltipResend" isOpen={tooltipOpen} toggle={toggleTooltip}>
                  Resend Authorization Mail
                </Tooltip>
              </React.Fragment>
            )}
          </Col>
        )}
      </Row>
      {(!attachmentDisabled || userType === UserType.MiddleOffice) && (value == "Written" || isProp) ? (
        <Requeriments
          setAttachment={setAttachment}
          downloadAttachment={downloadAttachment}
          orderPdf={orderPdf}
          orderId={orderId}
          onChangeOrder={(e) => onChangeOrder({ ...e, Instruction: restProps.value })}
          readonly={props.disabled && !userType === UserType.MiddleOffice}
          hasAttachment={hasAttachment}
          hasFile={hasFile}
          accountId={accountId}
        />
      ) : (
        <React.Fragment>
          {orderId && orderPdf && (
            <div className={style.requeriments}>
              <div className={style.line}>
                <span>Download order as pdf</span>
                <button
                  className={`mr-1 btn btn-light ${style.pdf}`}
                  tooltip="Download PDF"
                  tooltip-position="bottom"
                  onClick={() => orderPdf({ orderId })}
                >
                  <img />
                </button>
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Instruction;
